export enum BulkUploadPreviewModals {
  SHOW_NO_MODALS = 0,
  SHOW_IN_PROGRESS_MODAL = 1,
  SHOW_PARTIAL_UPLOAD_MODAL = 2,
  SHOW_SUCCESS_MODAL = 3,
}
